import { Spinner } from "./Spinner";

/** A reserved inline slot: background reads never insert a row above the content. */
export function BlogLoadingStatus({ busy, label = "Refreshing blog…" }: { busy: boolean; label?: string }) {
  return <span className="bw-blog-header-status" role="status">
    {busy && <><Spinner /><span className="bw-blog-status-label">{label}</span></>}
  </span>;
}
